module.exports = __webpack_public_path__ + "static/media/SILKSERIF-SEMIBOLD.21b184ff.woff";